// src/pages/LinkAccount.jsx
// Route: <Route exact path='/LinkAccount' component={LinkAccount} />

import React, { Component } from 'react';
import axios from 'axios';
import { FB_URL } from '../store/actions/types';

// Import the images
import createAccount1 from './create_account_1.png';
import createAccount2b from './create_account_2b.jpg';
import createAccount3 from './create_account_3.png';

const USER_LOGGED_IN = 'USER_LOGGED_IN';

class LinkAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'checking',
      errorMessage: '',
      email: '',
      token: '',
    };
  }

  componentDidMount() {
    console.log('LinkAccount: componentDidMount fired');

    const token = new URLSearchParams(window.location.search).get('token');
    console.log('LinkAccount: token =', token);

    if (!token) {
      this.setState({
        status: 'error',
        errorMessage: 'No token found in the link. Please request a new sign-in link from the Wisdom Agent.',
      });
      return;
    }

    // Store token in state so signup link can use it
    this.setState({ token });

    // Check if already signed in
    const storedUser = localStorage.getItem(USER_LOGGED_IN);
    if (storedUser) {
      try {
        const userObj = JSON.parse(storedUser);
        if (userObj.uid) {
          console.log('LinkAccount: user already signed in, uid =', userObj.uid);
          this.setState({ status: 'linking' });
          this.completeLink(token, userObj.uid, null);
          return;
        }
      } catch (err) {
        console.error('LinkAccount: parse error =', err);
      }
    }

    // Not signed in — show email form
    console.log('LinkAccount: user not signed in, showing email form');
    this.setState({ status: 'emailform' });
  }

  async completeLink(token, firebaseUid, email) {
    try {
      console.log('LinkAccount: calling completeTelegramLink');
      const linkRes = await axios.post(`${FB_URL}m126-completeTelegramLink`, {
        token,
        firebaseUid,
        email,
      });
      console.log('LinkAccount: response =', linkRes.data);

      if (linkRes.data?.notFound) {
        // No ThinkLead account found — show signup prompt
        this.setState({ status: 'signup', email });
        return;
      }

      if (!linkRes.data || !linkRes.data.success) {
        throw new Error(linkRes.data?.error || 'Linking failed.');
      }

      this.setState({ status: 'success' });

    } catch (err) {
      console.error('LinkAccount: error =', err);
      this.setState({
        status: 'error',
        errorMessage: err.message || 'Something went wrong. Please try again.',
      });
    }
  }

  handleEmailSubmit = async () => {
    const { email, token } = this.state;
    if (!email || !email.includes('@')) {
      this.setState({ errorMessage: 'Please enter a valid email address.' });
      return;
    }
    this.setState({ status: 'linking', errorMessage: '' });
    await this.completeLink(token, null, email);
  }

  render() {
    const { status, errorMessage, email, token } = this.state;

    return (
      <div style={{ maxWidth: 480, margin: '80px auto', padding: '0 24px', textAlign: 'center' }}>

        {status === 'checking' && (
          <p>Checking your link...</p>
        )}

        {status === 'emailform' && (
          <div>
            <h2>Connect your ThinkLead account</h2>
            <p>Enter the email address you use to sign in to ThinkLead.</p>
            <input
              type="email"
              value={email}
              onChange={e => this.setState({ email: e.target.value, errorMessage: '' })}
              placeholder="your@email.com"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '16px',
                marginBottom: '12px',
                boxSizing: 'border-box',
                border: '1px solid #ccc',
                borderRadius: '6px',
              }}
            />
            {errorMessage ? (
              <p style={{ color: 'red', fontSize: '14px' }}>{errorMessage}</p>
            ) : null}
            <button
              onClick={this.handleEmailSubmit}
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '16px',
                backgroundColor: '#1a73e8',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              Connect my account
            </button>
          </div>
        )}

        {status === 'signup' && (
          <div>
            <h2>No ThinkLead account found</h2>
            <p>
              We could not find a ThinkLead account for <strong>{email}</strong>.
            </p>
            {/* <p>
              Create your free account first — when you are done your Wisdom Agent
              will connect automatically. 
            </p>
            <a
              //href={`/signup?linkToken=${token}`}
              href={`/AgentSignup?linkToken=${token}`}
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#1a73e8',
                color: '#fff',
                borderRadius: '6px',
                textDecoration: 'none',
                fontSize: '16px',
                marginBottom: '16px',
              }}
            >
              Create my ThinkLead account
            </a> */}
                        <p>
              Create your free account first — when you are done, then return to your Agent. 
            </p>
            <a
              href={`/signup?linkToken=${token}`}
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#1a73e8',
                color: '#fff',
                borderRadius: '6px',
                textDecoration: 'none',
                fontSize: '16px',
                marginBottom: '16px',
              }}
            >
              CREATE ACCOUNT
            </a>
            <br />
            
      {/* Inserted Images - One below the other */}
      <div style={{ margin: '30px 0' }}>
              <img 
                src={createAccount1} 
                alt="Create Account Step 1" 
                style={{ 
                  width: '100%', 
                  maxWidth: '420px', 
                  borderRadius: '8px', 
                  marginBottom: '20px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }} 
              />
              
              <img 
                src={createAccount2b} 
                alt="Create Account Step 2" 
                style={{ 
                  width: '100%', 
                  maxWidth: '420px', 
                  borderRadius: '8px', 
                  marginBottom: '20px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }} 
              />
              
              <img 
                src={createAccount3} 
                alt="Create Account Step 3" 
                style={{ 
                  width: '100%', 
                  maxWidth: '420px', 
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }} 
              />
            </div>

            <br />

            <button
              onClick={() => this.setState({ status: 'emailform', errorMessage: '' })}
              style={{
                background: 'none',
                border: 'none',
                color: '#1a73e8',
                fontSize: '14px',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              Try a different email
            </button>
          </div>
        )}

        {status === 'linking' && (
          <p>Connecting your account...</p>
        )}

        {status === 'success' && (
          <div>
            <h2>You are connected</h2>
            <p>
              Your Telegram Agent is now linked to your ThinkLead account.
              Go back to Telegram to continue your conversation.
            </p>
          </div>
        )}

        {status === 'error' && (
          <div>
            <h2>Something went wrong</h2>
            <p>{errorMessage}</p>
            <p>Return to Telegram and type <strong>sign in</strong> to request a new link.</p>
          </div>
        )}

      </div>
    );
  }
}

export default LinkAccount;

///////////////////////////////////////////////////////////////////////////////////
// // src/pages/LinkAccount.jsx
// // Route: <Route exact path='/LinkAccount' component={LinkAccount} />

// import React, { Component } from 'react';
// import axios from 'axios';
// import { FB_URL } from '../store/actions/types';

// const USER_LOGGED_IN = 'USER_LOGGED_IN';

// class LinkAccount extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       status: 'checking',
//       errorMessage: '',
//       email: '',
//       token: '',
//     };
//   }

//   componentDidMount() {
//     console.log('LinkAccount: componentDidMount fired');

//     const token = new URLSearchParams(window.location.search).get('token');
//     console.log('LinkAccount: token =', token);

//     if (!token) {
//       this.setState({
//         status: 'error',
//         errorMessage: 'No token found in the link. Please request a new sign-in link from the Wisdom Agent.',
//       });
//       return;
//     }

//     // Store token in state so signup link can use it
//     this.setState({ token });

//     // Check if already signed in
//     const storedUser = localStorage.getItem(USER_LOGGED_IN);
//     if (storedUser) {
//       try {
//         const userObj = JSON.parse(storedUser);
//         if (userObj.uid) {
//           console.log('LinkAccount: user already signed in, uid =', userObj.uid);
//           this.setState({ status: 'linking' });
//           this.completeLink(token, userObj.uid, null);
//           return;
//         }
//       } catch (err) {
//         console.error('LinkAccount: parse error =', err);
//       }
//     }

//     // Not signed in — show email form
//     console.log('LinkAccount: user not signed in, showing email form');
//     this.setState({ status: 'emailform' });
//   }

//   async completeLink(token, firebaseUid, email) {
//     try {
//       console.log('LinkAccount: calling completeTelegramLink');
//       const linkRes = await axios.post(`${FB_URL}m126-completeTelegramLink`, {
//         token,
//         firebaseUid,
//         email,
//       });
//       console.log('LinkAccount: response =', linkRes.data);

//       if (linkRes.data?.notFound) {
//         // No ThinkLead account found — show signup prompt
//         this.setState({ status: 'signup', email });
//         return;
//       }

//       if (!linkRes.data || !linkRes.data.success) {
//         throw new Error(linkRes.data?.error || 'Linking failed.');
//       }

//       this.setState({ status: 'success' });

//     } catch (err) {
//       console.error('LinkAccount: error =', err);
//       this.setState({
//         status: 'error',
//         errorMessage: err.message || 'Something went wrong. Please try again.',
//       });
//     }
//   }

//   handleEmailSubmit = async () => {
//     const { email, token } = this.state;
//     if (!email || !email.includes('@')) {
//       this.setState({ errorMessage: 'Please enter a valid email address.' });
//       return;
//     }
//     this.setState({ status: 'linking', errorMessage: '' });
//     await this.completeLink(token, null, email);
//   }

//   render() {
//     const { status, errorMessage, email, token } = this.state;

//     return (
//       <div style={{ maxWidth: 480, margin: '80px auto', padding: '0 24px', textAlign: 'center' }}>

//         {status === 'checking' && (
//           <p>Checking your link...</p>
//         )}

//         {status === 'emailform' && (
//           <div>
//             <h2>Connect your ThinkLead account</h2>
//             <p>Enter the email address you use to sign in to ThinkLead.</p>
//             <input
//               type="email"
//               value={email}
//               onChange={e => this.setState({ email: e.target.value, errorMessage: '' })}
//               placeholder="your@email.com"
//               style={{
//                 width: '100%',
//                 padding: '12px',
//                 fontSize: '16px',
//                 marginBottom: '12px',
//                 boxSizing: 'border-box',
//                 border: '1px solid #ccc',
//                 borderRadius: '6px',
//               }}
//             />
//             {errorMessage ? (
//               <p style={{ color: 'red', fontSize: '14px' }}>{errorMessage}</p>
//             ) : null}
//             <button
//               onClick={this.handleEmailSubmit}
//               style={{
//                 width: '100%',
//                 padding: '12px',
//                 fontSize: '16px',
//                 backgroundColor: '#1a73e8',
//                 color: '#fff',
//                 border: 'none',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//               }}
//             >
//               Connect my account
//             </button>
//           </div>
//         )}

//         {status === 'signup' && (
//           <div>
//             <h2>No ThinkLead account found</h2>
//             <p>
//               We could not find a ThinkLead account for <strong>{email}</strong>.
//             </p>
//             {/* <p>
//               Create your free account first — when you are done your Wisdom Agent
//               will connect automatically. 
//             </p>
//             <a
//               //href={`/signup?linkToken=${token}`}
//               href={`/AgentSignup?linkToken=${token}`}
//               style={{
//                 display: 'inline-block',
//                 padding: '12px 24px',
//                 backgroundColor: '#1a73e8',
//                 color: '#fff',
//                 borderRadius: '6px',
//                 textDecoration: 'none',
//                 fontSize: '16px',
//                 marginBottom: '16px',
//               }}
//             >
//               Create my ThinkLead account
//             </a> */}
//                         <p>
//               Create your free account first — when you are done, then return to your Agent. 
//             </p>
//             <a
//               href={`/signup?linkToken=${token}`}
//               style={{
//                 display: 'inline-block',
//                 padding: '12px 24px',
//                 backgroundColor: '#1a73e8',
//                 color: '#fff',
//                 borderRadius: '6px',
//                 textDecoration: 'none',
//                 fontSize: '16px',
//                 marginBottom: '16px',
//               }}
//             >
//               CREATE ACCOUNT
//             </a>
//             <br />

//             {/* Insert pictures here --> */}

//             <button
//               onClick={() => this.setState({ status: 'emailform', errorMessage: '' })}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 color: '#1a73e8',
//                 fontSize: '14px',
//                 cursor: 'pointer',
//                 textDecoration: 'underline',
//               }}
//             >
//               Try a different email
//             </button>
//           </div>
//         )}

//         {status === 'linking' && (
//           <p>Connecting your account...</p>
//         )}

//         {status === 'success' && (
//           <div>
//             <h2>You are connected</h2>
//             <p>
//               Your ThinkLead account is now linked to your Wisdom Agent on Telegram.
//               Go back to Telegram to continue your conversation.
//             </p>
//           </div>
//         )}

//         {status === 'error' && (
//           <div>
//             <h2>Something went wrong</h2>
//             <p>{errorMessage}</p>
//             <p>Return to Telegram and type <strong>sign in</strong> to request a new link.</p>
//           </div>
//         )}

//       </div>
//     );
//   }
// }

// export default LinkAccount;

////////////////////////////////////////////////////////////////////////////////////////////
// // src/pages/LinkAccount.jsx
// // Add this as a route in your React app: <Route path="/link" element={<LinkAccount />} />
// // This page handles the handoff after the user taps the link from Telegram.

// import React, { useEffect, useState } from "react";
// import firebaseCompat from '../store/firebase';

// import { FB_URL } from '../store/actions/types'
// import firebase from '../store/firebase'
// import axios from "axios";

// export default function LinkAccount() {
//   const [status, setStatus] = useState("checking"); // checking | signin | linking | success | error
//   const [errorMessage, setErrorMessage] = useState("");

//   const token = new URLSearchParams(window.location.search).get("token");

//  useEffect(() => {
//   console.log("LinkAccount: useEffect fired");
//   console.log("LinkAccount: token =", token);
//   console.log("LinkAccount: FB_URL =", FB_URL);
//   console.log("LinkAccount: firebase =", firebase);
//   console.log("LinkAccount: firebase.auth =", firebase.auth);

//   if (!token) {
//     console.log("LinkAccount: no token found");
//     setStatus("error");
//     setErrorMessage("No token found in the link. Please request a new sign-in link from the Wisdom Agent.");
//     return;
//   }

//   console.log("LinkAccount: setting up onAuthStateChanged");
//   const unsubscribe = firebaseCompat.auth().onAuthStateChanged(async (firebaseUser) => {
//     console.log("LinkAccount: auth state changed, firebaseUser =", firebaseUser);
//     if (firebaseUser) {
//       console.log("LinkAccount: user is signed in, uid =", firebaseUser.uid);
//       setStatus("linking");
//       try {
//         const linkRes = await axios.post(`${FB_URL}/m126-completeTelegramLink`, {
//           token,
//           firebaseUid: firebaseUser.uid,
//         });
//         console.log("LinkAccount: linkRes =", linkRes.data);
//         if (!linkRes.data?.success) {
//           throw new Error(linkRes.data?.error || "Linking failed.");
//         }
//         setStatus("success");
//       } catch (err) {
//         console.error("LinkAccount: error =", err);
//         setStatus("error");
//         setErrorMessage(err.message || "Something went wrong. Please try again.");
//       }
//     } else {
//       console.log("LinkAccount: user is NOT signed in");
//       sessionStorage.setItem("pendingLinkToken", token);
//       setStatus("signin");
//     }
//   });

//   return () => unsubscribe();
// }, [token]);

//   return (
//     <div style={{ maxWidth: 480, margin: "80px auto", padding: "0 24px", textAlign: "center" }}>

//       {status === "checking" && (
//         <p>Checking your link...</p>
//       )}

//       {status === "signin" && (
//         <>
//           <h2>Sign in to connect your account</h2>
//           <p>
//             Please sign in to ThinkLead to connect your Wisdom Agent.
//             Once signed in, your account will be linked automatically.
//           </p>
//           {/* This sends them to your existing login page */}
//           <a href="/">Go to sign in</a>
//         </>
//       )}

//       {status === "linking" && (
//         <p>Connecting your account...</p>
//       )}

//       {status === "success" && (
//         <>
//           <h2>You are connected</h2>
//           <p>
//             Your ThinkLead account is now linked to your Wisdom Agent on Telegram.
//             Go back to Telegram to continue your conversation.
//           </p>
//         </>
//       )}

//       {status === "error" && (
//         <>
//           <h2>Something went wrong</h2>
//           <p>{errorMessage}</p>
//           <p>
//             Return to Telegram and type <strong>sign in</strong> to request a new link.
//           </p>
//         </>
//       )}

//     </div>
//   );
// }